import React from 'react';
import { Heart, Smile, TrendingUp, Users } from 'lucide-react';

const philosophyData = {
  headline: "Celebrating Every Body",
  message: "At Waisted Momma, we believe that confidence isn't about fitting into society's narrow definition of beauty—it's about feeling powerful, supported, and authentic in your own skin.",
  values: [
    {
      title: "Real Bodies Welcome",
      description: "We design for all shapes, sizes, and stages of life. Your body is perfect as it is."
    },
    {
      title: "Comfort First",
      description: "Beauty should never mean sacrifice. Our pieces support you without restricting you."
    },
    {
      title: "Transformation on Your Terms",
      description: "Whether you're postpartum, on a fitness journey, or simply want that extra confidence—we support your goals, your way."
    },
    {
      title: "Community Over Comparison",
      description: "We're building a sisterhood of women who lift each other up, celebrate wins, and embrace authenticity."
    }
  ]
};

const icons = {
  'Real Bodies Welcome': Users,
  'Comfort First': Smile,
  'Transformation on Your Terms': TrendingUp,
  'Community Over Comparison': Heart
};

const PhilosophySection = () => {
  return (
    <section className="section-spacing bg-gradient-to-br from-primary/5 via-accent/5 to-secondary/10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-serif font-semibold text-foreground mb-6">
            {philosophyData.headline}
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-3xl mx-auto leading-relaxed">
            {philosophyData.message}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {philosophyData.values.map((value, index) => {
            const IconComponent = icons[value.title] || Heart;
            return (
              <div 
                key={index} 
                className="bg-white rounded-2xl p-8 shadow-lg card-hover"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-blush rounded-xl shadow-sm flex-shrink-0">
                    <IconComponent className="w-6 h-6 accent-gold" />
                  </div>
                  <div>
                    <h3 className="text-xl font-serif font-semibold text-foreground mb-3">
                      {value.title}
                    </h3>
                    <p className="text-base text-muted-foreground font-sans leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
